import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface BannerProps {
  theme: 'info' | 'warning' | 'error' | 'success' | 'action-required';
}

export interface BannerConfig {
  theme: string;
  title: string;
  description?: string;
  buttonText?: string;
  buttonUrl?: string;
  bannerIcon?: 'error' | 'info' | 'warning' | 'success'
}

export const icons = {
  'error': `<svg xmlns="http://www.w3.org/2000/svg" width="35" height="34" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.389 30.436c7.995 0 14.476-6.134 14.476-13.7 0-7.568-6.481-13.702-14.476-13.702-7.996 0-14.477 6.134-14.477 13.701S9.393 30.436 17.39 30.436Z" fill="#F6CCCE"/><rect x="15.941" y="9.885" width="2.895" height="10.961" rx="1" fill="currentColor"/><rect x="15.941" y="22.216" width="2.895" height="2.74" rx="1" fill="currentColor"/></svg>`,
  'info': `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path d="M12 1.999C17.523 1.999 22 6.477 22 12.001c0 5.523-4.478 10.001-10.001 10.001-5.524 0-10.002-4.478-10.002-10.001C1.998 6.477 6.476 1.998 12 1.998Zm0 1.5a8.502 8.502 0 1 0 0 17.003A8.502 8.502 0 0 0 12 3.5Zm-.004 7a.75.75 0 0 1 .743.648l.007.102.004 5.502a.75.75 0 0 1-1.493.102l-.007-.101-.004-5.502a.75.75 0 0 1 .75-.75ZM12 7.002a.999.999 0 1 1 0 1.997.999.999 0 0 1 0-1.997Z" fill="currentColor"/></svg>`,
  'warning': `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path d="M13 17a.999.999 0 1 0-1.998 0 .999.999 0 0 0 1.997 0Zm-.26-7.853a.75.75 0 0 0-1.493.103l.004 4.501.007.102a.75.75 0 0 0 1.493-.103l-.004-4.502-.007-.101Zm1.23-5.488c-.857-1.548-3.082-1.548-3.938 0L2.286 17.66c-.83 1.5.255 3.34 1.97 3.34h15.49c1.714 0 2.799-1.84 1.969-3.34L13.969 3.66Zm-2.626.726a.75.75 0 0 1 1.313 0l7.745 14.002a.75.75 0 0 1-.656 1.113H4.256a.75.75 0 0 1-.657-1.113l7.745-14.002Z" fill="currentColor"/></svg>`,
  'success': `<svg width="28" height="28" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.682 7.75c0 3.746-3.063 6.781-6.782 6.781A6.78 6.78 0 0 1 .12 7.75C.12 4.031 3.153.969 6.9.969c3.72 0 6.782 3.062 6.782 6.781Zm-7.575 3.61 5.032-5.032a.463.463 0 0 0 0-.629l-.63-.601a.387.387 0 0 0-.6 0L5.806 9.199 3.865 7.285a.387.387 0 0 0-.601 0l-.63.602a.463.463 0 0 0 0 .629l2.845 2.843a.463.463 0 0 0 .628 0Z" fill="currentColor"/></svg>`,
  'action-required': `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M12 2.09998C17.523 2.09998 22 6.57798 22 12.1C22 17.622 17.523 22.1 12 22.1C6.477 22.1 2 17.622 2 12.1C2 6.57798 6.477 2.09998 12 2.09998ZM12 3.76698C7.405 3.76698 3.667 7.50498 3.667 12.1C3.667 16.695 7.405 20.433 12 20.433C16.595 20.433 20.333 16.695 20.333 12.1C20.333 7.50498 16.595 3.76698 12 3.76698ZM11.9987 14.6022C12.5502 14.6022 12.9973 15.0493 12.9973 15.6009C12.9973 16.1524 12.5502 16.5995 11.9987 16.5995C11.4471 16.5995 11 16.1524 11 15.6009C11 15.0493 11.4471 14.6022 11.9987 14.6022ZM11.9945 7.09998C12.3742 7.09967 12.6882 7.38158 12.7381 7.74761L12.7451 7.84938L12.7487 12.351C12.749 12.7652 12.4135 13.1012 11.9993 13.1016C11.6196 13.1019 11.3055 12.82 11.2556 12.4539L11.2487 12.3522L11.2451 7.85058C11.2447 7.43636 11.5802 7.10031 11.9945 7.09998Z" fill="#BD271E"/></svg>`
}

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  @Input() theme!: string;
  @Input() title: string = `We need your attention!`
  @Input() description: string;
  @Input() buttonText: string;
  @Input() buttonUrl: string;
  @Input() showCloseButton: boolean = false;
  @Input() customHandler: boolean = false;
  @Input() customClickHandler: Function;
  @Output() close: EventEmitter<void> = new EventEmitter<void>(); // Add this line

  closeBanner(): void {
    this.close.emit();
  }
  bannerIcon: string;
  @Output() buttonClick = new EventEmitter ();
  constructor() { }

  ngOnInit(): void {
    this.bannerIcon = icons[this.theme]
  }

  openInNewTab(buttonUrl){
    window.open(buttonUrl, '_blank');
  }
  handleButtonClick(event: Event): void {
    event.stopPropagation();
    this.buttonClick.emit(event); 
    if (this?.customHandler) {
      // event.preventDefault(); 
      // event.stopPropagation(); 
      if (this?.customClickHandler) {
        this.customClickHandler(this.buttonText); 
      }
    } else {
      console.log("Navigating to:", this.buttonUrl);
    }
  }


}
